import ImagesUrl from "#constants/images.js";
import React from "react";
import CustomInput from "../../CustomInput";

const SeedComponent = ({
  values,
  handleChange,
  handleBlur,
  errors,
  touched,
  parentIndex,
}) => {
  return (
    <div className="custom_accordion_item">
      <button
        className="custom_accordion d-flex w-100 justify-content-between align-items-center border-0"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target={`#collapseCrop_2${parentIndex}`}
        aria-expanded="false"
        aria-controls={`collapseCrop_2${parentIndex}`}
      >
        <p className="m-0 fertility_text">Seed</p>
        <span className="drop_icon">
          <img
            className="drop_icon"
            src={ImagesUrl.dopeIcon}
            alt="drop-icon .."
          />
        </span>
      </button>
      <div
        className="custom_collapse_body collapse"
        id={`collapseCrop_2${parentIndex}`}
      >
        <div className="common-collapse_blk">
          <div className="row gy-4">
            <div className="col-lg-6">
              <div className="common-modal-field">
                <CustomInput
                  label={"Variety"}
                  value={values?.data?.[parentIndex]?.seed?.variety || ""}
                  name={`data[${parentIndex}].seed.variety`}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className="form-control undefined"
                  placeholder="Enter Variety"
                  error={errors?.data?.[parentIndex]?.seed?.variety}
                  touched={touched?.data?.[parentIndex]?.seed?.variety}
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="common-modal-field">
                <CustomInput
                  label={"Rate"}
                  value={values?.data?.[parentIndex]?.seed?.rate || ""}
                  name={`data[${parentIndex}].seed.rate`}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className="form-control undefined"
                  placeholder="Enter Rate"
                  error={errors?.data?.[parentIndex]?.seed?.rate}
                  touched={touched?.data?.[parentIndex]?.seed?.rate}
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="common-modal-field">
                <CustomInput
                  label={"Unit"}
                  value={values?.data?.[parentIndex]?.seed?.unit || ""}
                  name={`data[${parentIndex}].seed.unit`}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className="form-control undefined"
                  placeholder="Enter Unit"
                  error={errors?.data?.[parentIndex]?.seed?.unit}
                  touched={touched?.data?.[parentIndex]?.seed?.unit}
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="common-modal-field">
                <CustomInput
                  label={"Quantity"}
                  value={values?.data?.[parentIndex]?.seed?.quantity || ""}
                  name={`data[${parentIndex}].seed.quantity`}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className="form-control undefined"
                  placeholder="Enter Quantity"
                  error={errors?.data?.[parentIndex]?.seed?.quantity}
                  touched={touched?.data?.[parentIndex]?.seed?.quantity}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SeedComponent;
